var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamRahmen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Cam_Rahmen__Icn/40px/Cam_Rahmen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Cam_Rahmen__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Cam_Rahmen__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.999,25.999 L8,28 L9.998,28 L9.999,30 L6,30 L5.999,25.999 L7.999,25.999 Z M15.999,25.999 L16,30 L11.999,30 L11.998,28 L14,28 L13.999,25.999 L15.999,25.999 Z M18,10 C18.5522847,10 19,10.4477153 19,11 L19,12 L30,12 C31.0543618,12 31.9181651,12.8158778 31.9945143,13.8507377 L32,14 L32,25 C32,26.1045695 31.1045695,27 30,27 L19,27 L19,25 L30,25 L30,14 L18,14 C17.4477153,14 17,13.5522847 17,13 L17,12 L16,12 L16,13 C16,13.5128358 15.6139598,13.9355072 15.1166211,13.9932723 L15,14 L12,14 L12,18 L10,18 L10,14 C10,12.9456382 10.8158778,12.0818349 11.8507377,12.0054857 L12,12 L14,12 L14,11 C14,10.4871642 14.3860402,10.0644928 14.8833789,10.0067277 L15,10 L18,10 Z M22.5,15 C24.9852814,15 27,17.0147186 27,19.5 C27,21.9852814 24.9852814,24 22.5,24 C20.0147186,24 18,21.9852814 18,19.5 C18,17.0147186 20.0147186,15 22.5,15 Z M16,20 L15.999,23.999 L13.999,23.999 L14,22 L11.998,22 L11.999,20 L16,20 Z M9.999,20 L9.998,22 L8,22 L7.999,23.999 L5.999,23.999 L6,20 L9.999,20 Z M22.5,17 C21.1192881,17 20,18.1192881 20,19.5 C20,20.8807119 21.1192881,22 22.5,22 C23.8807119,22 25,20.8807119 25,19.5 C25,18.1192881 23.8807119,17 22.5,17 Z",
    id: ".._.._src_svg_Icn_40px_Cam_Rahmen__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamRahmen);
export default __webpack_public_path__ + "static/media/Cam_Rahmen.f71165a7c2b3de1660253b08f580030c.svg";
export { ForwardRef as ReactComponent };